import React from 'react'
import './bussiness_auto_insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
const BussinessAutoInsurance = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business auto insurance", link: "" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Business auto coverages",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Smart conversations',
        blue_para: 'As the business world incorporates new technology, insurance providers need to keep pace. With coverages for electronic data processing, computer-related losses, and more, we’re doing exactly that.',
        purple_icon: images['Icon_of_two_purple_cups.svg'],
        purple_heading: 'Need extra protection?',
        purple_para: "If you need to file a claim, our claims staff is ready to help you 24/7.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['Icon_of_two_people_arm_in_arm.svg'],
            para: 'You want to protect your business and plan for your future. As one of the financially strongest mutual insurance companies in the country, we’re ready to help you find the insurance solutions you’re looking for.',
            para1: 'Whether you’re a small business owner or you’re seeking coverage for a large corporation with complex risks, we have a wide range of business insurance products that can help you protect what matters most.',
        },
    ];
    return (
        <>
            <div className='bussiness_auto_insurance'>
                {/* hero section */}
                <Hero img={images["two_men_seated_talking.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Business auto insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    <SentryCard data={sectrydata} />
                    {/* Plans section */}
                    <Plans data={plansData} />
                    {/* news card section */}
                    <NewsCard Title="Business auto coverages
                        "CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} />
                    {/* news  */}
                    <NewsCard Title="News and resources
                    "CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default BussinessAutoInsurance;